import {
	BOOKED_TRANSPORT_EVENT_NAME,
	INSIGHTS_SEARCH,
	JOIN_MOTORWAY_PAY_CTA_EVENT_NAME,
	OFFERS_BIN_EVENT_NAME,
	PAGE_AUCTION,
	PAGE_BIDS_ACTIVE,
	PAGE_BIDS_DIDNT_WIN,
	PAGE_BIDS_UNDER_OFFER,
	PAGE_BUY_IT_NOW,
	PAGE_INSIGHTS,
	PAGE_MOTORWAY_MOVE,
	PAGE_MOTORWAY_MOVE_CLICK_BOOK_DELIVERY,
	PAGE_MOTORWAY_PAY,
	PAGE_MOTORWAY_TRADE,
	PAGE_PURCHASES_CANCELLED,
	PAGE_PURCHASES_COMPLETED,
	PAGE_SHORTLIST,
	PAGE_VEHICLE_PAYMENT_CONFIRMATION,
	PAGE_WALLET,
	PROXY_BID_EVENT_NAME,
	PURCHASES_BIN_EVENT_NAME,
	REQUEST_CALL_MOTORWAY_PAY_EVENT_NAME,
	VIEWS_AUCTION_EVENT_NAME,
	VIEWS_BIN_EVENT_NAME,
} from './brazeEvents.const';
import { sendBrazeCustomEvent } from './brazeEvents.helpers';

export const sendBrazeProxyBidEvent = async (enquiryId: number): Promise<void> => {
	const BID_EVENT_PAYLOAD = {
		enquiryId,
	};

	await sendBrazeCustomEvent(PROXY_BID_EVENT_NAME, BID_EVENT_PAYLOAD);
};

export const sendBrazeViewsAuctionEvent = async (enquiryId: number): Promise<void> => {
	const VIEWS_AUCTION_EVENT_PAYLOAD = {
		enquiryId,
	};

	await sendBrazeCustomEvent(VIEWS_AUCTION_EVENT_NAME, VIEWS_AUCTION_EVENT_PAYLOAD);
};

export const sendBrazeViewsBINEvent = async (enquiryId: number): Promise<void> => {
	const VIEWS_BIN_EVENT_PAYLOAD = {
		enquiryId,
	};

	await sendBrazeCustomEvent(VIEWS_BIN_EVENT_NAME, VIEWS_BIN_EVENT_PAYLOAD);
};

export const sendBrazeOfferBINEvent = async (enquiryId: number): Promise<void> => {
	const OFFER_BIN_EVENT_PAYLOAD = {
		enquiryId,
	};

	await sendBrazeCustomEvent(OFFERS_BIN_EVENT_NAME, OFFER_BIN_EVENT_PAYLOAD);
};

export const sendBrazePurchaseBINEvent = async (enquiryId: number): Promise<void> => {
	const PURCHASE_BIN_EVENT_PAYLOAD = {
		enquiryId,
	};

	await sendBrazeCustomEvent(PURCHASES_BIN_EVENT_NAME, PURCHASE_BIN_EVENT_PAYLOAD);
};

export const sendBrazeBookedTransportEvent = async (enquiryId: number): Promise<void> => {
	const BOOKED_TRANSPORT_EVENT_PAYLOAD = {
		enquiryId,
	};

	await sendBrazeCustomEvent(BOOKED_TRANSPORT_EVENT_NAME, BOOKED_TRANSPORT_EVENT_PAYLOAD);
};

export const sendBrazeBidsActiveEvent = async (): Promise<void> => sendBrazeCustomEvent(PAGE_BIDS_ACTIVE);

export const sendBrazeBidsUnderOfferEvent = async (): Promise<void> => sendBrazeCustomEvent(PAGE_BIDS_UNDER_OFFER);

export const sendBrazeBidsDidntWinEvent = async (): Promise<void> => sendBrazeCustomEvent(PAGE_BIDS_DIDNT_WIN);

export const sendBrazePurchasesCompletedEvent = async (): Promise<void> =>
	sendBrazeCustomEvent(PAGE_PURCHASES_COMPLETED);

export const sendBrazePurchasesCancelledEvent = async (): Promise<void> =>
	sendBrazeCustomEvent(PAGE_PURCHASES_CANCELLED);

export const sendBrazeWalletEvent = async (): Promise<void> => sendBrazeCustomEvent(PAGE_WALLET);

export const sendBrazeMotorwayPayEvent = async (): Promise<void> => sendBrazeCustomEvent(PAGE_MOTORWAY_PAY);

export const sendBrazeMotorwayTradeEvent = async (): Promise<void> => sendBrazeCustomEvent(PAGE_MOTORWAY_TRADE);

export const sendBrazeRequestCallMotorwayPayEvent = async (): Promise<void> =>
	sendBrazeCustomEvent(REQUEST_CALL_MOTORWAY_PAY_EVENT_NAME);

export const sendBrazeMotorwayPayCTAEvent = async (): Promise<void> =>
	sendBrazeCustomEvent(JOIN_MOTORWAY_PAY_CTA_EVENT_NAME);

export const sendBrazeAuctionEvent = async (): Promise<void> => sendBrazeCustomEvent(PAGE_AUCTION);

export const sendBrazeBuyItNowEvent = async (): Promise<void> => sendBrazeCustomEvent(PAGE_BUY_IT_NOW);

export const sendBrazeShortlistEvent = async (): Promise<void> => sendBrazeCustomEvent(PAGE_SHORTLIST);

export const sendBrazeVehiclePaymentConfirmationEvent = async (enquiryId: number): Promise<void> => {
	const VEHICLE_PAYMENT_CONFIRMATION_EVENT_PAYLOAD = {
		enquiryId,
	};

	await sendBrazeCustomEvent(PAGE_VEHICLE_PAYMENT_CONFIRMATION, VEHICLE_PAYMENT_CONFIRMATION_EVENT_PAYLOAD);
};

export const sendBrazeMotorwayMoveEvent = (): Promise<void> => sendBrazeCustomEvent(PAGE_MOTORWAY_MOVE);

export const sendBrazeMotorwayMoveBookDeliveryEvent = (): Promise<void> =>
	sendBrazeCustomEvent(PAGE_MOTORWAY_MOVE_CLICK_BOOK_DELIVERY);

export const sendBrazeInsightsEvent = async (): Promise<void> => sendBrazeCustomEvent(PAGE_INSIGHTS);

export const sendBrazeInsightsSearchEvent = async ({
	makePretty,
	modelPretty,
	similarVehiclesEnquiryIds,
}: {
	makePretty: string;
	modelPretty: string;
	similarVehiclesEnquiryIds: number[];
}): Promise<void> => {
	const payload: {
		enquiryId?: string;
		makeModel: string;
	} = {
		makeModel: `${makePretty}, ${modelPretty}`,
	};

	if (similarVehiclesEnquiryIds.length) {
		payload.enquiryId = similarVehiclesEnquiryIds.join(', ');
	}

	await sendBrazeCustomEvent(INSIGHTS_SEARCH, payload);
};
